class Lottie {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {boolean}
         */
        this.isLoaded = false;
        /**
         * @type function
         */
        this.onload = () => {
        };
        /**
         * Load script
         */
        Helper.loadScript('/theme/cnosf/asset/vendor/js/lottie.min.js').then(() => {
            this.isLoaded = true;
            return this.onload();
        });
    }

    /**
     * On ready
     */
    static runAnimation(element) {
        const PATH    = element.getAttribute('data-lottie-path');
        const REQUEST = new XMLHttpRequest();

        REQUEST.open('GET', PATH);

        REQUEST.onload = () => {

            try {
                lottie.loadAnimation({
                    container: element,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    animationData: JSON.parse(REQUEST.response)
                });
            } catch (e) {
                console.log('File animation bot valid');
            }

        };

        REQUEST.send();
    }

}